import { render } from "./RoleForm.vue?vue&type=template&id=151fad3b&scoped=true&ts=true"
import script from "./RoleForm.vue?vue&type=script&lang=ts"
export * from "./RoleForm.vue?vue&type=script&lang=ts"

import "./RoleForm.vue?vue&type=style&index=0&id=151fad3b&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151fad3b"]])

export default __exports__